export enum PurchaseRequestAuditStatus {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export interface PurchaseRequestAuditAuthorDto {
  name: string;
  avatarUrl?: string;
}

export interface PurchaseRequestAuditRequestDto {
  purchaseId: string;
  page?: number;
  pageSize?: number;
}

export interface PurchaseRequestAuditDto {
  id: number;
  /** Ação de auditoria do backend (ver `PurchaseRequestAuditAction`); string para tolerar valores novos. */
  action?: string;
  message: string;
  status: PurchaseRequestAuditStatus;
  createdAt: string;
  author: PurchaseRequestAuditAuthorDto;
}
